import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadComissaoCorretora = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      minWidth: "30px",
      width: "30px",
      align: "left",
    },
    {
      title: "Código",
      align: "left",
      minWidth: "70px",
      width: "70px",
    },
    {
      title: "Ver comissão",
      minWidth: "80px",
      width: "80px",
      align: "left",
    },
    {
      title: "Operadora",
      minWidth: "150px",
      align: "left",
      width: "150px",
    },
    {
      title: "Administradora",
      minWidth: "150px",
      width: "150px",
      align: "left",
    },
    {
      title: "Modalidade",
      minWidth: "150px",
      width: "150px",
      align: "left",
    },
    {
      title: "Vitalício",
      minWidth: "120px",
      align: "center",
      width: "120px",
    },
    {
      title: "Vigência",
      minWidth: "120px",
      align: "center",
      width: "120px",
      infoTitle: "Comissão valida a partir desta data",
    },
    {
      title: "Ativa",
      minWidth: "100px",
      align: "center",
      width: "100px",
      infoTitle: "Comissão ativa ficara disponível para utilizar em contratos",
    },
    {
      title: "Info",
      align: "center",
      width: "50px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
